module.exports = function getGroups(str) {
    return str.split(/[:\s+]/);
};



// WEBPACK FOOTER //
// ./src/TimeInput/lib/get-groups.js